// extracted by mini-css-extract-plugin
module.exports = {"memberLink":"ReportedBy__memberLink___v1-RM","user":"ReportedBy__user___gVNBF","postedTime":"ReportedBy__postedTime___J5H9Z"};